<template>
  <div>
    <div class="breadcrumb-nav">
      <a href="/">首页</a>&gt;&gt;
      <a href="/www/organization/chairman">组织机构</a>&gt;&gt;联盟理事长
    </div>
    <div class="subRight">
      <div class="subRightTit">
        <span>联盟理事长</span>

      </div>
      <div class="con">
        <table
          cellspacing="0"
          cellpadding="0"
          class="orgTbl m-hide"
        >
          <tbody>
            <tr>
              <th
                colspan="5"
                width="759"
              >理事长单位</th>
            </tr>
            <tr>
              <td class="thead">职位</td>
              <td class="thead">姓名</td>
              <td class="thead">职称</td>
              <td class="thead">职务</td>
              <td class="thead">工作单位</td>
            </tr>
            <tr
              v-for="item in data1"
              :key="item.id"
            >
              <td>{{ item.position }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.duty }}</td>
              <td>{{ item.org_name }}</td>
            </tr>
            <tr>
              <th
                colspan="5"
                width="759"
              >副理事长单位（按单位名称拼音顺序排列）</th>
            </tr>
            <tr>
              <td class="thead">职位</td>
              <td class="thead">姓名</td>
              <td class="thead">职称</td>
              <td class="thead">职务</td>
              <td class="thead">工作单位</td>
            </tr>
            <tr
              v-for="item in data2"
              :key="item.id"
            >
              <td>{{ item.position }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.duty }}</td>
              <td>{{ item.org_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Chairman",
  data (){
    return {
      data1: [],
      data2: []
    }
  },
  methods: {
    async getData(){
      await this.$http.get('/allowany/org_leader/', {
        params: {
          page: 1,
          size: 10000,
          type: 1,
        }
      }).then((data) => {
        this.data1 = data.results
      })

      await this.$http.get('/allowany/org_leader/', {
        params: {
          page: 1,
          size: 10000,
          type: 2,
        }
      }).then((data) => {
        this.data2 = data.results
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>
td {
  width: 100px;
}

td:nth-child(4) {
  width: 200px;
}
td:last-child {
  width: 200px;
}
</style>
